import React from 'react';
import { Select } from 'antd';

export const LCSelect = props => 
    <Select {...props}>{props.content}</Select>;
